export default "__VITE_ASSET__b9T86et9__"